export enum DocumentStatus {
Draft,
Issued,
Cancelled,
}
